module.exports = __webpack_public_path__ + "img/916.37ea047d.png";